import styled from 'styled-components';
import { UnstyledButtonMixin } from '../../mixins/components/UnstyledButtonMixin';

/**
 * A button element with default browser styles overwritten to produce a style
 * agnostic button.
 *
 * This component is intended to be used to provide an accessible element for performing
 * actions. For instance, `onClick` on a `span` is not accessible to keyboard-based users without
 * additional work such as having appropriate keystroke event listeners (i.e. onKeyDown for Enter).
 *
 * By utilizing a `button` DOM node as a wrapper to an `span`, the click event listener,
 * subsequently moved to the button, is invoked natively by the browser without any
 * additional attributes necessary for keyboard-based interactions.
 *
 * See [MDN documentation on `button`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button)
 * for a list of permitted content.
 *
 * @since 8.30.0
 */
var UnstyledButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "UnstyledButton",
  componentId: "c11n-8-111-1__sc-13jpj60-0"
})(["", ""], UnstyledButtonMixin);
UnstyledButton.displayName = 'UnstyledButton';
UnstyledButton.defaultProps = {
  type: 'button'
};

/** @component */
export { UnstyledButton };